import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder,FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ActionSheetController, AlertController, LoadingController, MenuController, ModalController, PopoverController } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';
// import { ComFilterLeadsComponent } from '../com-filter-leads/com-filter-leads.component';
// import { LeadsUpdateStatusPage } from '../leads-update-status/leads-update-status.page';
// import { UtilService } from '../services/util/util.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-user-group-edit',
  templateUrl: './user-group-edit.component.html',
  styleUrls: ['./user-group-edit.component.scss'],
})
export class UserGroupEditComponent implements OnInit {

  load: boolean = false;
  namagrup: any = '';

  
  manjang: boolean = false;
  baseUrl: any = '';
  provision_key: any = '';
  client_id: any = '';
  client_secret: any = '';
  grant_type: any = '';
  authUrl: any = '';

  chartt: any;
  info: string = "leads";
  accor:any = '';
  accorr:any = '';

  isIndeterminate:boolean;
  masterCheck:boolean;
  checkBoxList:any;

  page: any = 1;

  fractionSize;
  ionicForm: FormGroup;
  isSubmitted = false;
  nn: any = '';
  form: any = '';

  user: any;
  token: any;
  hasil: any;

  leadn: any = {};
  lnores: any = {};
  listData: any;
  aa: any;

  opsi:boolean=false;
  totalCekData: any;
  pageInfo: any = {};
  pageNation: any;

  viewType: any;

  filter: any = '';
  filterr: any = '';

  resAr: any;
  add: any = {};

  accordionExpanded = false;
  checkbox1 = false;
  checkbox2 = false;

  descgrup: any = '';
  copyfrom: any = '';

  dataTemp: any = {};
  dt: any;

  dataGetM: any = {};
  gm: any = {};
  gMenu: any;

  saving: any = {};
  id: any;

  listDataPost: any;

  constructor(
    public popoverController: PopoverController,
    public modalController: ModalController,
    public menuCtrl: MenuController,
    public route: Router,
    public api: ApiService,
    public util: UtilService,
    public activatedRoute: ActivatedRoute
  ) {
    this.baseUrl = environment.restURL.baseUrl;
    this.activatedRoute.queryParams.subscribe(params => {
      if (params && params.no) {
        this.id = params.no;
        console.log('id', this.id)
      }
    });
  }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    this.token = localStorage.getItem('usertoken') || '';
    // this.ionicForm = this.formBuilder.group({
    //   name: ['']
    // });
  }

  ionViewWillEnter() {
    this.page = 1;
    this.res();
    this.template();
  }

  nav(p: any) {
    this.route.navigate([p]);
  }

  save() {
    this.load = true;
  
    // Proses indeterminate -> selected = true
    // this.listDataPost = this.prepareListDataPost(this.listData);
  
    let form = {
      name: this.namagrup,
      desc: this.descgrup,
      menu: this.listData
    };
  
    console.log('Form', form);
  
    this.api.put('backoffice/group-menu/' + this.id, form)
      .subscribe((data) => {
        this.saving = data;
        this.load = false;
        if (this.saving.error == 0) {
          this.nav('./grup-menu');
          this.util.showToast(this.saving.message, 'success', 'bottom');
        } else {
          this.util.showToast(this.saving.message, 'danger', 'bottom');
        }
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error);
      });
  }
  

  prepareListDataPost(data: any[]): any[] {
    return data.map(menu => {
      const clonedMenu = { ...menu };
  
      if (clonedMenu.indeterminate) {
        clonedMenu.selected = true;
      }
  
      if (clonedMenu.children && Array.isArray(clonedMenu.children)) {
        clonedMenu.children = clonedMenu.children.map(child => {
          const clonedChild = { ...child };
          if (clonedChild.indeterminate) {
            clonedChild.selected = true;
          }
  
          // No need to modify action.enable here unless needed
          return clonedChild;
        });
      }
  
      return clonedMenu;
    });
  }
  

  template(){
    this.load = true;
    this.api.get('data/master/group-menu')
      .subscribe((data) => {
        this.dataTemp = data;
        if (this.dataTemp.error == 0) {
          this.load = false;
          this.dt = this.dataTemp.data;
          console.log('dt',this.dt);
        } else {
          this.load = false;
          this.util.showToast(this.dataTemp.message, 'success', 'bottom');
        }
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error)
      });
  }

  // Perbarui kode TypeScript agar memperhatikan status 'selected' dan 'enable' pada inisialisasi dan pengolahan data

getMenu(id: any){
  if(id !== ''){
    this.load = true;
    this.api.get('backoffice/group-menu/template-menu/'+id)
      .subscribe((data) => {
        this.dataGetM = data;
        if (this.dataGetM.error == 0) {
          this.load = false;
          this.gm = this.dataGetM.data;
          this.gMenu = this.gm.menu;
          this.listData = this.gMenu;
          console.log('gm',this.gm);
          this.initializeSelectionState(this.listData);
          this.setParentReferences();
        } else {
          this.load = false;
          this.util.showToast(this.dataGetM.message, 'success', 'bottom');
        }
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error)
      });
  } else {
    this.listData = this.leadn.data.menu;
    this.isIndeterminate = false;
    this.masterCheck = false;
  }
}

initializeSelectionState(data: any[], parent: any = null) {
  data.forEach(item => {
    item.parent = parent;

    if (typeof item.selected === 'undefined') item.selected = false;
    if (typeof item.enable === 'undefined') item.enable = true;

    // Force unselect if disabled
    if (item.enable === false) item.selected = false;

    if (typeof item.indeterminate === 'undefined') item.indeterminate = false;

    if (item.actions) {
      item.actions.forEach(action => {
        if (typeof action.enable === 'undefined') action.enable = false;

        // Action also can't be enabled if its parent is disabled
        if (item.enable === false) action.enable = false;
      });
    }

    if (item.children) {
      this.initializeSelectionState(item.children, item);
    }
  });
}


checkMaster() {
  setTimeout(() => {
    this.listData.forEach(obj => {
      if (obj.enable !== false) {
        obj.selected = this.masterCheck;
        this.checkChildren(obj, this.masterCheck);
        this.toggleActions(obj, this.masterCheck, obj);
      }
    });
  });
}

toggleAccordion() {
  this.accordionExpanded = !this.accordionExpanded;
}

checkEventAction() {
  let childSelected = false;

  this.listData.forEach(rootItem => {
    let childSelectedInRoot = false;

    if (rootItem.children) {
      rootItem.children.forEach(childItem => {
        // Hanya tetapkan childSelectedInRoot jika childItem.selected === true
        if (childItem.selected === true) {
          childSelectedInRoot = true;
          childSelected = true;
        }

        if (childItem.actions) {
          // Jika ada actions yang aktif, artinya child dianggap aktif
          const hasEnabledAction = childItem.actions.some(action => action.enable === true);
          if (hasEnabledAction) {
            childSelectedInRoot = true;
            childSelected = true;
          }
        }
      });
    }

    // Hanya atur selected = true jika benar-benar ada selected anak atau aksi aktif
    rootItem.selected = childSelectedInRoot;
  });

  this.isIndeterminate = childSelected;
}

toggleCheck(menuItem: any, isParent: boolean, data: any) {
  if (!menuItem.children || menuItem.children.length === 0) {
    // ✅ Jika tidak ada children, hanya set selected langsung
    menuItem.selected = isParent;
    return;
  }

  if (isParent) {
    // ✅ Jika menu dicentang
    this.checkChildren(menuItem, menuItem.selected);
    this.toggleActions(menuItem, menuItem.selected, data);
    this.updateIndeterminateStatus(menuItem);
  } else {
    // ✅ Jika menu tidak dicentang
    this.toggleParentCheck(menuItem.parent);
    this.toggleChildren(menuItem, menuItem.selected);
    this.toggleActions(menuItem, menuItem.selected, data);
    const aa = Array.isArray(data?.children) ? data.children.find(item => item.selected === true) : null;
    if (!aa) {
      this.checkParentAction(data, isParent);
    }
    this.updateIndeterminateStatus(data);
  }

  // Selalu update status parent
  this.updateIndeterminateStatus(data);
}


toggleChild(child: any, isChecked: boolean, parent: any) {
  child.selected = isChecked;
  child.indeterminate = false;

  // Update action checkbox
  if (child.actions) {
    child.actions.forEach((action: any) => {
      action.enable = isChecked;
    });
  }

  this.updateIndeterminateStatus(parent);
}

 
toggleActions(actionItem: any, _childSelected: boolean, child: any) {
  if (!Array.isArray(child.actions) || child.actions.length === 0) {
    this.updateIndeterminateStatus(child);
    return;
  }
  

  const total = child.actions.length;
  const checked = child.actions.filter(a => a.enable).length;

  if (checked === total) {
    child.selected = true;
    child.indeterminate = false;
  } else if (checked === 0) {
    child.selected = false;
    child.indeterminate = false;
  } else {
    child.selected = false;
    child.indeterminate = true;
  }

  // Update status parent setelah perubahan di action
  this.updateIndeterminateStatus(child);
}


updateIndeterminateStatus(menuItem: any) {
  if (!menuItem || (!menuItem.children || menuItem.children.length === 0)) {
    if (Array.isArray(menuItem?.actions) && menuItem.actions.length > 0) {
      const totalActions = menuItem.actions.length;
      const enabledActions = menuItem.actions.filter(a => a.enable).length;

      if (enabledActions === 0) {
        menuItem.selected = false;
        menuItem.indeterminate = false;
      } else if (enabledActions === totalActions) {
        menuItem.selected = true;
        menuItem.indeterminate = false;
      } else {
        menuItem.selected = false;
        menuItem.indeterminate = true;
      }
    } else {
      // Tidak punya children dan actions
      if (menuItem) {
        menuItem.selected = false;
        menuItem.indeterminate = false;
      }
    }
    return;
  }

  let selectedCount = 0;
  let indeterminateFound = false;

  for (const child of menuItem.children) {
    if (child.indeterminate) indeterminateFound = true;
    if (child.selected) selectedCount++;

    if (Array.isArray(child.actions)) {
      const actionEnabled = child.actions.filter(a => a.enable).length;
      if (actionEnabled > 0 && actionEnabled < child.actions.length) {
        indeterminateFound = true;
      }
    }
  }

  const totalChildren = menuItem.children.length;

  if (indeterminateFound || (selectedCount > 0 && selectedCount < totalChildren)) {
    menuItem.selected = false;
    menuItem.indeterminate = true;
  } else {
    menuItem.indeterminate = false;
    menuItem.selected = selectedCount === totalChildren;
  }

  if (menuItem.parent) {
    this.updateIndeterminateStatus(menuItem.parent);
  }
}



checkParentAction(data: any, isParent: boolean) {
  data.selected = isParent;

}

checkParentCheck(childItem: any) {
  if (childItem.parent) {
    const allChildrenSelected = childItem.parent.children.every((child: any) => child.selected);
    childItem.parent.selected = allChildrenSelected;
    this.checkParentCheck(childItem.parent);
  }
}

toggleChildren(menuItem: any, selected: boolean) {
  if (menuItem.children) {
    menuItem.children.forEach(child => {
      if (child.enable !== false) {
        child.selected = selected;
        this.checkActions(child, selected);
        this.toggleChildren(child, selected);
      }
    });
  }
}

checkChildren(menuItem: any, selected: boolean) {
  if (menuItem.children) {
    menuItem.children.forEach(child => {
      if (child.enable !== false) {
        child.selected = selected;
        this.checkActions(child, selected);
        this.checkChildren(child, selected);
      }
    });
  }
}

checkActions(menuItem: any, selected: boolean) {
  if (menuItem.actions) {
    menuItem.actions.forEach(action => {
      action.enable = selected;
    });

    // Update status indeterminate dan parent
    this.updateIndeterminateStatus(menuItem);
  }
}


updateParentCheck(menuItem: any) {
  if (menuItem.parent) {
    const allChildrenChecked = menuItem.parent.children.every(child => child.selected);
    const allActionsChecked = menuItem.parent.children.every(child => {
      if (child.actions) {
        return child.actions.every(action => action.enable);
      }
      return true;
    });
    menuItem.parent.selected = allChildrenChecked && allActionsChecked;
    this.updateParentCheck(menuItem.parent);
  }
}

toggleParentCheck(parentItem: any) {
  if (parentItem) {
    parentItem.selected = parentItem.children.every(child => child.selected);
    this.toggleParentCheck(parentItem.parent);
  }
}

checkEvent() {
  const totalItems = this.listData.length;
  let checked = 0;
  this.listData.forEach(obj => {
    if (obj.selected) checked++;
  });

  this.isIndeterminate = checked > 0 && checked < totalItems;
  this.masterCheck = checked === totalItems;
  this.aa = checked > 0 ? this.listData.filter(item => item.selected) : '';
  this.opsi = checked > 0;
  this.totalCekData = checked;

  try {
    this.listData.forEach(rootItem => {
      if (rootItem.children) {
        rootItem.children.forEach(childItem => {
          if (childItem.enable !== false) {
            childItem.selected = rootItem.selected;
            if (childItem.actions) {
              childItem.actions.forEach(actionItem => {
                actionItem.enable = rootItem.selected;
              });
            }
          }
        });
      }
    });
  } catch (error) {}

  console.log('aa', this.aa);
  console.log('opsi', this.opsi);
  console.log('listData', this.listData);
}

setParentReferences() {
  this.listData.forEach(menu => {
    if (menu.children) {
      menu.children.forEach(child => {
        child.parent = menu;
        if (child.actions) {
          child.actions.forEach(action => {
            action.parent = child;
          });
        }
      });
    }
  });
}

onActionToggle(child: any) {
  if (!child || !child.actions || !Array.isArray(child.actions)) return;

  const total = child.actions.length;
  const checked = child.actions.filter(a => a.enable).length;

  if (checked === total) {
    child.selected = true;
    child.indeterminate = false;
  } else if (checked === 0) {
    child.selected = false;
    child.indeterminate = false;
  } else {
    // ⚠️ Jangan ubah selected menjadi false jika indeterminate
    child.indeterminate = true;
    // child.selected tetap sesuai nilai sebelumnya
  }

  // Update status parent (rekursif)
  this.updateIndeterminateStatus(child.parent);
}




  res() {
    console.log('pageNotResponse',this.page);
    let a = {
      name: this.nn,
    }
    this.form = JSON.stringify({
      q: a,
      page: this.page,
    });
    console.log('FORM', this.form);
    this.load = true;
    // this.api.get('backoffice/group-menu/template-menu'+this.filterr)
    this.api.get('backoffice/group-menu/list/'+this.id)
      .subscribe((data) => {
        this.leadn = data;
        if (this.leadn.error == 0) {
          this.load = false;
          this.lnores = this.leadn.data;
          this.listData = this.leadn.data.menu;
          this.descgrup = this.leadn.data.desc;
          this.namagrup = this.leadn.data.name;
          console.log('lnores',this.lnores);

        } else {
          this.load = false;
          this.util.showToast(this.leadn.message, 'success', 'bottom');
        }
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error)
      });
  }

  acc(aa: any){
    console.log('val', aa);
    var bb = aa.toString();
    if(this.accor == ''){
      this.accor = bb;
      console.log('1')
    } else if (this.accor == bb){
      this.accor = '';
      console.log('2')
    } else {
      this.accor = bb;
      console.log('3')
    }
    console.log('accor', this.accor);
  }
 
  openOpsi(){
    if(this.opsi == false){
      this.opsi = true;
    } else {
      this.opsi = false;
    }
    console.log(this.opsi);
  }

  dismiss(){
    this.opsi = false;
  }

  det(p){
    let navigationExtras: NavigationExtras = {
       queryParams: {
         no: p,
         fromPage:'leads'
       }
     };
     this.route.navigate(['./leads-detail'], navigationExtras);
   }


  submit(){
  }




}
